import loadable from '@loadable/component';

export default loadable(
    () => import(/* webpackChunkName: 'terms_and_conditions_checkbox' */'./TermsAndConditionsCheckbox')
);
